<template>
	<div class="FOutDoor">
		<div class="scanCont">
			<div class="cont">
				<img class="ScanImg" src="../../../../static/FreshCabinet/images/bmp_closedoor1.png" alt="">
				<div class="tit">{{ScanTips}}</div>
			</div>
			<div class="scanBtn">
				<span></span>
				<span></span>
			</div>
			<div class="ScanTime">{{CountTime}}s</div>
		</div>
		
		<!--按钮组-->
		<EConfigBtn :pushBg="'#31a3dc'" :backUp="backUp" :quit="quit"></EConfigBtn>
		<!--超时组件-->
		<overTime :callBack="backUp"></overTime>
		<!--loading -->
		<ELoading v-if="isLoading" :Msg="loadingTips"></ELoading>
	</div>
</template>

<script>
	import overTime from '../assets/overTime.vue'
	import EConfigBtn from '../assets/ConfigBtn.vue'
	import ELoading from '../assets/Loading.vue'
	import storageGetOpenTips from '../../../../static/FreshCabinet/mp3/storage_get_open_tips.mp3'
	import { conLog,storage } from '../../../../static/js/utils/utility'
	var vm
	export default {
		name:'FOutDoor',
		data() {
			return {
				isLanguage:0,
				Language:'',
				
				ScanTips:'',//提示语
				OutNum:'',//箱格号
				
				scanInfo:{
					ExpressNum:'',
				},
				
				//超时
				CountTime:40,
				CountTimeStatus:'',
				isCount:true,
				
				loadingTips:'',
				isLoading:false,//是否显示loading组件
			};
		},
		components:{
			overTime,
			EConfigBtn,
			ELoading
		},
		created(){
			vm = this
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				vm.isLanguage = isLanguage
			}
			vm.Language = vm.$Language
			
			vm.$store.state.overTime = 80
			
			if(this.isLanguage == 0){
				this.ScanTips = this.$route.query.BoxNumber + this.$Language.LG.OutDoorTips[this.isLanguage]
			}else{
				this.ScanTips = 'Locker '+ this.$route.query.BoxNumber + this.$Language.LG.OutDoorTips[this.isLanguage]
			}
			
			//箱门已打开，请取出您的包裹
			var url = storageGetOpenTips
			var audio = new Audio(url);
			audio.src = url;
			audio.play();
			
			this.CountDown(this.CountTime)
		},
		methods:{
			//重置时间
			reTime(){
				this.$store.state.overTime = 80
			},
			
			//返回上一页
			backUp(){
				vm.$router.push({
					path:'/FreshCabinet/FOutStock',
				})
			},
			//退出登录
			quit(){
				vm.$router.push({
					path:'/FreshCabinet',
				})
			},
			
			//超时
			CountDown(wait){
				var that = this;
				if(wait == 0) {
					this.CountTime = wait
					clearTimeout(that.CountTimeStatus)
					this.quit()
					// that.isCount = false
					// that.ScanTips = this.$Language.LG.ScanFailure[this.isLanguage]
				} else {
					this.CountTime = wait
					wait --;
					that.CountTimeStatus = setTimeout(function() {
						that.CountDown(wait);
					},1000);
				}
			},
		},
		destroyed(){
			clearTimeout(this.CountTimeStatus)
		},
	}
</script>

<style lang="less">
.FOutDoor{
	position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
	background: #f2f2f2;
	text-align: center;
	
	.scanCont{
		position: absolute;
		width: 50%;
		left: 50%;
		margin-left: -25%;
		top: 50%;
		margin-top: -3.59rem;
		color: #31a3dc;
		.ScanTime{
			position: absolute;
			left: calc(50% + 208.33rem);
			top: 10%;
			font-size: 0.3rem;
			white-space: nowrap;
		}
		.scanBtn{
			background: #fff;
			box-shadow: 0 0.02rem 0.03rem 0.02rem rgba(0,0,0,.12);
			padding: 0.25rem 0.25rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-radius: 0.1rem;
		}
		.cont{
			background: #fff;
			padding-top: 0.3rem;
			box-shadow: 0 0.02rem 0.03rem 0.02rem rgba(0,0,0,.12);
			margin-bottom: 0.1rem;
			border-radius: 0.1rem;
			.tit{
				font-size: 0.4rem;
				color: #31a3dc;
				padding: 0.15rem;
			}
			.ScanImg{
				width: 5.76rem;
				height: 4.31rem;
			}
		}
	}
	.overTime{
		color: #666;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/FreshCabinet/OutDoor/OutDoor.vue